import axios from 'axios';
import { auth } from '../firebase';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api'
});

// Add auth token to requests
api.interceptors.request.use(
  async (config) => {
    // Bypass server-side cache when cache is disabled via env var
    if (config.method === 'get' && process.env.REACT_APP_DISABLE_CACHE === 'true') {
      config.params = { ...config.params, nocache: 'true' };
    }
    try {
      // Determine if we need authentication
      const isLocalhost = window.location.hostname === 'localhost';
      const apiURL = config.baseURL || config.url || '';
      const isLocalAPI = apiURL.includes('localhost') || apiURL.includes('127.0.0.1');

      // Skip auth only if BOTH frontend and API are localhost
      if (isLocalhost && isLocalAPI) {
        // No auth token needed when both are running locally
        return config;
      }

      // Get the current user's ID token (even in development when calling production API)
      const token = await auth.currentUser?.getIdToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else if (isLocalhost && !isLocalAPI) {
        // Development mode calling production API but no token available
        // Add a development bypass header (backend needs to handle this)
        console.warn('⚠️ Development mode: No auth token available for production API call');
        config.headers['X-Dev-Mode'] = 'true';
      }
    } catch (error) {
      console.error('Error getting auth token:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for handling auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Token expired or invalid - could trigger logout here
      console.error('Authentication error:', error.response?.data);
    }
    return Promise.reject(error);
  }
);

export default api;